import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../../theme/tokens';
import { Table, Text } from '../../../../../components';

/** The guide: tabs, the active client's steps, then the server settings. */
export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** A tab panel with more than one child (the Gmail route: its caveat, then its steps). */
export const GuidePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** Numbered steps under the active tab. */
export const Steps = styled.ol`
  margin: 0;
  padding-left: ${SPACE[20]};
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const Step = styled.li`
  font-size: 13px;
  line-height: 1.55;
  color: ${COLORS.textMuted};
`;

/** The server-settings unit: heading, description, table. */
export const Settings = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const SettingsHeading = styled(Text)`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.textStrong};
`;

export const SettingsDescription = styled(Text)`
  font-size: 12px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** The ONE element on the page allowed to scroll sideways: the table keeps its four columns at
 *  phone width inside this wrapper rather than squeezing them. */
export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

/** Monospaced machine values in the server cells. */
export const Mono = styled.code`
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  white-space: nowrap;
  color: ${COLORS.textStrong};
`;

/**
 * The shared Table's header treatment out-shouts the page's stat labels here, so bring the headers
 * onto the label treatment through Table's public className. COUPLING: targets the `Text` span
 * inside each header cell (`th > span`); if Table's head markup changes, this is the one place to
 * update.
 */
export const SettingsTable = styled(Table)`
  min-width: 480px;

  th > span {
    font-size: 11px;
    font-weight: normal;
    letter-spacing: 0.04em;
    color: ${COLORS.textFaint};
  }
` as typeof Table;
